import { trustStats, trustPillars } from "@/mocks/home";

export default function TrustSection() {
  return (
    <section id="trust" className="w-full px-4 md:px-10 py-14 md:py-20">
      <div className="rounded-lg border hairline bg-background-100/70 overflow-hidden">
        <div className="px-5 md:px-10 pt-8 md:pt-12 pb-8 md:pb-10 border-b hairline">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            <div className="max-w-2xl">
              <span className="text-xs md:text-sm tracking-[0.3em] text-primary-600 uppercase">
                Why Trust Us
              </span>
              <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                追新料，也追靠谱
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                爱黑料网最看重的是「快」和「准」之间的那条线。每条料带可信度标签，
                来源可回溯，变化了会回到原条更新，而不是制造新的噪音。
              </p>
            </div>
            <a
              href="#faq"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-foreground-950 text-background-50 text-sm md:text-base font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap shrink-0 cursor-pointer"
            >
              <i className="ri-question-answer-line text-lg" />
              看常见问题
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-foreground-950/8 border-b hairline">
          {trustStats.map((stat) => (
            <div key={stat.label} className="px-5 md:px-8 py-6 md:py-8">
              <p className="font-heading text-3xl md:text-4xl font-black text-primary-500">
                {stat.value}
              </p>
              <p className="mt-2 font-heading text-base font-bold text-foreground-950">
                {stat.label}
              </p>
              <p className="mt-1 text-xs md:text-sm text-foreground-500">{stat.note}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-foreground-950/8">
          {trustPillars.map((pillar) => (
            <div key={pillar.title} className="px-5 md:px-8 py-6 md:py-8">
              <span className="w-11 h-11 rounded-md bg-accent-100 text-accent-800 flex items-center justify-center">
                <i className={`${pillar.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-950">
                {pillar.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{pillar.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}